import { Box, Button, Typography } from '@mui/material'
import React, { useContext } from 'react'
import { useCallableRef } from '../../../api/useCallableRef'
import useUserDetails from '../../../common/hooks/useUserDetails'
import ProgressCircle from '../../../common/components/ProgressCircle'
import { SnackbarHelperContext } from '../../../common/contexts/SnackbarHelperContext'

export default function BillingDetails() {
  const { loadingUser, userDetails } = useUserDetails()
  const { setSnackbarSettings } = useContext(SnackbarHelperContext)

  const [createPortalSession, executingCreatePortalSession] = useCallableRef('createPortalSession')

  async function directToCustomerPortal() {
    try {
      const portalSession = await createPortalSession({
        stripeId: userDetails?.stripeCustomerId,
        redirectUrl: window.location.href,
      })
      const url = (portalSession?.data as any)?.url
      if (url) {
        window.location.replace(url)
      } else {
        console.error('createPortalSession response:', portalSession)
        setSnackbarSettings({
          severity: 'error',
          message: 'Unable to open billing portal. Please try again.',
          autoHideDuration: 6000,
        })
      }
    } catch (err) {
      console.error('createPortalSession error:', err)
      setSnackbarSettings({
        severity: 'error',
        message: 'Unable to open billing portal. Please try again.',
        autoHideDuration: 6000,
      })
    }
  }

  if (loadingUser || executingCreatePortalSession) {
    return <ProgressCircle />
  }

  if (!userDetails?.stripeCustomerId) {
    return (
      <Box p={2}>
        <Typography variant="body1">No billing information available.</Typography>
      </Box>
    )
  }

  return (
    <Box p={2} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Typography variant="body1">
        Manage your subscriptions, invoices, and payment methods through the billing portal.
      </Typography>
      <Box>
        <Button
          variant="contained"
          onClick={directToCustomerPortal}
          sx={{
            fontWeight: 700,
            background: '#008000',
            '&:hover': {
              backgroundColor: '#006600',
            },
          }}
        >
          Manage Billing
        </Button>
      </Box>
    </Box>
  )
}
